module.exports = __webpack_public_path__ + "img/SE.d46dbac2.svg";